import { HTMLAttributes } from 'react';
import { formatNumber } from '../../utils/formatNumber';

export function FloatNumberField({
  className,
  value,
  unit,
}: {
  value: number | undefined;
  unit?: string;
} & HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={`flex gap-1 items-baseline text-sm font-semibold whitespace-nowrap text-neutrals-900 ${className}`}>
      <div>
        {value !== undefined && value !== null
          ? formatNumber(value.toString(), false)
          : '--'}{' '}
      </div>
      <div className="text-neutrals-700">{unit}</div>
    </div>
  );
}
